import { styled } from '@linaria/react';
import { space } from '../../theme/tokens';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-400']};
`;
